
const TrackBlock = ({ html }: { html: string }) => {
  return (
    <div className="track">
      <div className="trackLine"></div>
      <div className="trackBox">
        <div className="trackCircle">
          <div className="innerTrackCircle"></div>
        </div>
        <div
          className="trackContent"
          dangerouslySetInnerHTML={{ __html: html }}
        ></div>
      </div>
    </div>
  );
};

export default TrackBlock;
